import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-video-service',
  templateUrl: './video-service.component.html',
  styleUrls: ['./video-service.component.css'],
})
export class VideoServiceComponent {
  @Input() data!: any;
  @Input() language!: string;
  
}
